import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import "./ProductCardList.scss";

const ProductCardList = (props) => {
  const Comp = props.component;

  return (
    <div className="product-card-list-grid">
      {props.productRow.map((items, i) => {
        const hasBadge = items.some(
          (item) =>
            item.showBadge !== "false" &&
            (item.badgeContent || item.productBadgeContent)
        );
        return (
          <div
            className={cx("product-card-list-row", {
              "product-card-list-row--has-badge": hasBadge,
            })}
            key={i}
          >
            {items.map((item) => (
              <Comp
                showArrow={props.showArrow}
                key={item.productId}
                showDescription={props.showDescription}
                showPrice={props.showPrice}
                ageRangeLabel={props.ageRangeLabel}
                {...item}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
};

ProductCardList.propTypes = {
  productRow: PropTypes.array.isRequired,
  ageRangeLabel: PropTypes.string,
  showDescription: PropTypes.bool,
  showPrice: PropTypes.bool,
  showBadge: PropTypes.string,
  showArrow: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

export default ProductCardList;
